/**
 * 入住人冲突
 */
import React from 'react';
import { Modal, Col, Row } from 'antd';
import intl from 'react-intl-universal';

import { PortalInstance } from '@/components/PortalConfirm';
import BaseService from '@/api/checkInBase';
import { CheckInGuestInfo } from '@/redux/reducers/reservation/base.d';

// import styles from './index.module.scss';

interface ConflictInfo {
  certNo: string; // 证件号
  commonCode: string; // 门店码
  commonName: string; // 门店名称
  memberType: 0 | 1 | 2; // 0房主，1普通租客，2访客	integer(int32)
  name: string; // 姓名
  roomNo: string; // 房间号
}

const showConflictModal = (portal: PortalInstance, detail: ConflictInfo, callback: () => void) => {
  try {
    Modal.warning({
      title: intl.get('drawer_checkin_guest_conflict_title'),
      content: (
        <>
          <Row>
            <Col span={24} style={{ marginBottom: '16px' }}>
              {intl.get('drawer_checkin_guest_conflict_content', {
                name: detail.name,
                certNo: detail.certNo,
              })}
            </Col>
          </Row>
          <Row>
            <Col span={4} style={{ fontWeight: 'bold' }}>
              {intl.get('drawer_checkin_guest_conflict_store_name')}
            </Col>
            <Col>{`${detail.commonCode} ${detail.commonName}`}</Col>
          </Row>
          <Row>
            <Col span={4} style={{ fontWeight: 'bold' }}>
              {intl.get('app_constants_room_no')}
            </Col>
            <Col>{detail.roomNo}</Col>
          </Row>
        </>
      ),
      okText: intl.get('app_confirm_close_btn'),
      onOk: () => {
        callback();
      },
    });
  } catch (e) {
    callback();
  }
};

// 入住冲突校验
const checkGuestConflict: (
  portal: PortalInstance,
  guestList: CheckInGuestInfo[], // 宾客列表
) => Promise<void> = (portal, guestList) => {
  return new Promise((resolve, reject) => {
    const wyuids = [];
    guestList.forEach((item) => {
      if (item.wyuId) {
        wyuids.push(item.wyuId);
      }
    });
    if (wyuids.length) {
      BaseService.checkGuestConflict({ wyuids }).then(
        (res) => {
          const list: ConflictInfo[] = res.data || [];
          //  房主 或者 入住人
          const target = list.find((item) => item.memberType === 0 || item.memberType === 1);
          if (target) {
            showConflictModal(portal, target, reject);
          } else {
            resolve();
          }
        },
        () => {
          reject();
        },
      );
    } else {
      resolve();
    }
  });
};

export default checkGuestConflict;
